<template>
  <b-form-group label="Status do aluno">
    <multiselect
      :value="computedValue"
      :options="myOptions"
      :multiple="false"
      :close-on-select="true"
      :clear-on-select="false"
      :preserve-search="true"
      :placeholder="placeholder"
      label="designation"
      track-by="id"
      selectLabel=""
      selectedLabel=""
      deselectLabel=""
      @select="callback"
    >
      <span slot="noResult">Nada encontrado</span>
    </multiselect>
  </b-form-group>
</template>

<script>
export default {
  props: {
    placeholder: {
      default: "Todos",
      type: String,
    },
    selected: { default: null },
    value: {},
    callback: {},
    status: null,
  },
  data() {
    return {
      options: "",
      studentsStatus: [],
    };
  },

  mounted() {
    if (this.selected !== null && this.selected !== undefined) {
      this.value = this.selected;
    }
  },

  methods: {
    clearAll() {
      this.studentsStatus = [];
    },
  },
  computed: {
    myOptions() {
      return [
        { designation: "Ativo", id: true },
        { designation: "Inativo", id: false },
        { designation: "Todos", id: null },
      ];
    },
    computedValue() {
      return this.myOptions.find((c) => c.id == this.value);
    },
  },
};
</script>
